import { useQuery } from "@tanstack/react-query";

import CustomTableService from "services/CustomTable";
import { customTableSchemaKey } from "routes/custom_tables/grid/queryKeys";

export const useCustomTableSchema = slug => {
  const { data, isFetched, isError } = useQuery({
    queryKey: customTableSchemaKey(slug),
    queryFn: () => CustomTableService.get(slug),
    enabled: !!slug,
    retry: false,
  });

  return { schema: data, isFetched, isError };
};
